// Shared types + fetchers for the followers / following list endpoints.
// Both endpoints return the same shape (paginated rows + metadata) so a
// single `FollowListPage` type covers both call sites.

import { api } from './api';
import type { DonorTier } from './stores/auth';

/**
 * One row in a paginated followers / following list. `is_following`
 * reflects the VIEWER's relation to this row (not the list-owner's), so
 * the SPA can render a per-row FollowButton without an extra lookup.
 */
export interface FollowListRow {
  username: string;
  donor_tier: DonorTier;
  /** ISO timestamp — when the underlying follow edge was created. */
  followed_at: string;
  is_following: boolean;
}

export interface FollowListPage {
  rows: FollowListRow[];
  page: number;
  per_page: number;
  total: number;
  last_page: number;
}

export async function fetchFollowers(username: string, page = 1): Promise<FollowListPage> {
  return api<FollowListPage>(
    `/api/users/${encodeURIComponent(username)}/followers?page=${page}`,
  );
}

export async function fetchFollowing(username: string, page = 1): Promise<FollowListPage> {
  return api<FollowListPage>(
    `/api/users/${encodeURIComponent(username)}/following?page=${page}`,
  );
}
